import { render } from "./BotonIngresoEmbargoGobernacionComponent.vue?vue&type=template&id=4e85b3c4"
import script from "./BotonIngresoEmbargoGobernacionComponent.vue?vue&type=script&lang=js"
export * from "./BotonIngresoEmbargoGobernacionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__